/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Notices_Status_InactiveInputs */

const en_carrier_notices_status_inactive = /** @type {(inputs: Carrier_Notices_Status_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inactive`)
};

const es_carrier_notices_status_inactive = /** @type {(inputs: Carrier_Notices_Status_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inactivo`)
};

/**
* | output |
* | --- |
* | "Inactive" |
*
* @param {Carrier_Notices_Status_InactiveInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_notices_status_inactive = /** @type {((inputs?: Carrier_Notices_Status_InactiveInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Notices_Status_InactiveInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_notices_status_inactive(inputs)
	return es_carrier_notices_status_inactive(inputs)
});